import member1 from "./assets/members/member1.png";
import member2 from "./assets/members/member2.png";
import member3 from "./assets/members/member3.png";
import member4 from "./assets/members/member4.png";
import member5 from "./assets/members/member5.png";
import member6 from "./assets/members/member6.png";

export const MAIN = {
  preSale: {
    title: "PRE-SALE",
    subtitle: "Price: 0.06ETH",
    content: "Date: TBA",
    url: "", // Opens a new tab with given url, when clicked to sale button
  },
  publicSale: {
    title: "PUBLIC SALE",
    subtitle: "Price: 0.08ETH",
    content: "Date: TBA",
    url: "", // Opens a new tab with given url, when clicked to sale button
  },
};

export const SOCIAL = {
  twitter: "https://twitter.com/RebelTigerClub",
  instagram: "https://www.instagram.com/rebeltigerclub/",
  discord: "https://discord.gg/rebeltigerclub",
  opensea: "",
};

export const ABOUT_SECTION = {
  firstParagraph:
    "“Hundreds of years ago a rebellion started and took the jungle by storm. 9,999 rebel tigers gathered, all unique but equally rebellious, with a purpose to revolt against the tyrants of the digital world. This was only the beginning for the REBEL TIGER CLUB.”",
  subtitle1: "Welcome to the Rebel Tiger Club",
  secondParagraph:
    "The REBEL TIGER CLUB is an exclusive collection of 9,999 Rebel Tiger NFTs - Individually unique digital collectibles. which are essentially provably unique digital assets. The tigers are created as ERC-721 tokens live and rebel in the Ethereum blockchain, they are securely hosted on IPFS. Rarities and certain attributes are all stored on-chain. \n\n RTC is comprised of 180 rebellious traits that were all drawn by hand. Each and every Tiger NFT is special in it’s own way and will be an exclusive membership to the Rebellion. Join the Rebellion and be a part of a community that aims to shake things up in the metaverse.",
  subtitle2: "Together.",
  thirdParagraph:
    "Ownership of a Rebel Tiger Club NFT promises much more than owning a unique piece of art, it is also your membership to the most exclusive rebellion on the blockchain.  Membership to this rebellion will be full of benefits and incentives, both on the blockchain and IRL . Some of these benefits are listed on the roadmap! RTC’s grand vision is to establish a digital world where digital-ownership rights are acknowledged , with barriers such as censorship and access restriction eliminated. With that in mind, RTC will take every legal action to rebel against digital dictators. Your Rebel Tiger will serve as your digital identity, helping you to rise against centralized digital dictatorships!",
};

export const ROADMAP = [
  {
    title: "0% - REBELLION HAS STARTED",
    height: 275, // DO NOT TOUCH THIS LINE
    mobileHeight: 200, // DO NOT TOUCH THIS LINE
    content:
      "Buckle up! Rebellious discord becomes available for Rebel Tigers. Join the Rebellion to get early access and participate in giveaways. 9,999 Rebel Tigers are on the way, presale whitelisting will be available, our early supporters will be rewarded greatly. ",
  },
  {
    title: "20% - PRE-DRINK",
    height: 50, // DO NOT TOUCH THIS LINE
    mobileHeight: 50, // DO NOT TOUCH THIS LINE
    content: "10 rebels from our community will be airdropped a Rebel Tiger.",
  },
  {
    title: "40% - REBEL WALLET FUNDED ",
    height: 300, // DO NOT TOUCH THIS LINE
    mobileHeight: 200, // DO NOT TOUCH THIS LINE
    content:
      "Funding for Rebel Tiger Club! We are 100% dedicated to the success of our Rebellious project and are fully aware of what it takes for a project to succeed. These funds will be used for our marketing campaigns to spread RTC, as well as invest in strategies to build long term value for our tigers.",
  },
  {
    title: "60% - REBELS GIVE BACK",
    height: 200, // DO NOT TOUCH THIS LINE
    mobileHeight: 200, // DO NOT TOUCH THIS LINE
    content:
      "Time to give back! Get ready for our daily NFT and ETH giveaways. Our most active and dedicated community members will be rewarded. That’s not all! Our community will also choose a worthy charity for a donation.",
  },
  {
    title: "80% - REBELS FEEL GOOD AND LOOK GOOD",
    height: 250, // DO NOT TOUCH THIS LINE
    mobileHeight: 200, // DO NOT TOUCH THIS LINE
    content:
      "Exclusive access to rebel Merch and network. Rebels will be collaborating with big players to continue to bring value to RTC.  The most active Rebels in the community will be rewarded greatly. Real holders will get a chance to win neon light frame of their Rebel Tiger.",
  },
  {
    title: "100% - REBELLIONS IS AT FULL FORCE",
    height: 250, // DO NOT TOUCH THIS LINE
    mobileHeight: 200, // DO NOT TOUCH THIS LINE
    content:
      "Once our rebellion is at full force, we will be UNSTOPPABLE. Development roadmap begins, implementation of strategies to build long term value for our holders, as well as the development and implementation of $RBL.",
  },
];

export const DEV_ROADMAP = [
  {
    title: "UNLOCK TRAIT UTILITY",
    content:
      "Every Tiger is valuable and unique. Some tigers will have special traits with utility, which RTC will reveal as the Rebellion progresses.",
  },
  {
    title: "REBELLION FUNDRAISING",
    content:
      "Every Tiger is dedicated to the success of the Rebellion. With this dedication comes a responsibility to fundraise. Each Rebel Tiger Club NFT will earn $RBL. Rebel Tiger Points can be used for the exclusive RTC Merch Shop, Special Events (Training and Rebellion, minting future projects, and much more). The daily earnings of each Tiger will depend on many factors. More on this as the project progresses.",
  },
  {
    title: "REBELLION TRAINING",
    content:
      "During Rebellion Training a RTC member can spend their Rebel Tiger Points, $RBL, to send their tiger to Rebellion Training. Training unlocks a new trait “Trained” as well as increase stats.  Stats affect daily points yield; a tiger can be sent to training 3 times. Once 3 trainings are complete, Elite Rebel Tiger Title unlocked. ",
  },
  {
    title: "REBELLION",
    content:
      "Elite Rebel Tigers are the only Tigers than can participate in a Rebellion. Warning tiger may die in Rebellion. Surviving Tigers earn Rebellion trait and get “Rebel Torn Tiger Club” Collection!",
  },
  {
    title: "REBEL SUPPLY STORE",
    content:
      "The rebel supply store will have exclusive merch only for RTC members, as well as Rebel items to enhance fundraising, training and rebellion.",
  },
  {
    title: "ARSENAL",
    content:
      "To immortalize our community we will be launching a collaborative text on the blockchain, where all our holders can express themselves in their own unique way.  This collection of thoughts and expressions will represent our community in the most Rebelliously unique way.",
  },
  {
    title: "METAVERSE DEVELOPMENT",
    content: "TBD",
  },
  {
    title: "ESTABLISH DAO",
    content:
      "Rebels will vote and participate in project development decisions.",
  },
];

export const GENERALS = {
  text: "The most important and influential members of the Rebellion. The Rebel Generals are not only powerful but also 15 of the most valuable pieces of the Rebel Tiger Club NFT Collection. Each and every General is a unique 1:1 with legendary traits unique to themselves. Owning and holding any of these will bring unimaginable benefits to the holder, which will be revealed as the project progresses.\n\nHere are some benefits we are willing to share for now..",
  listTitle: "Rebel Generals Utility",
  list: [
    "Base $RBL yield comes maxed",
    "Guaranteed free mints for all future projects",
    "Discounted mints for all future projects once free mints are capped holders can also buy more mints at discount",
    "Special Airdrops to holders",
    "Priority on all future developments tied to RTC",
  ],
};

export const TEAM = [
  {
    image: member1, // DO NOT TOUCH THIS LINE
    name: "0xCRYPTONY",
    role: "Founder, CEO",
    social: {
      instagram: "https://www.instagram.com/ataberktekin/",
      twitter: "https://twitter.com/0xcryptony",
      linkedin: "",
    },
  },
  {
    image: member2, // DO NOT TOUCH THIS LINE
    name: "0xOPCODE",
    role: "Founder, CTO",
    social: {
      instagram: "https://www.instagram.com/efeacerr/",
      twitter: "https://twitter.com/0xOPCODE",
      linkedin: "https://www.linkedin.com/in/efeacer/",
    },
  },
  {
    image: member3, // DO NOT TOUCH THIS LINE
    name: "MAC",
    role: "COO",
    social: {
      instagram: "",
      twitter: "https://twitter.com/theninjahokage",
      linkedin: "https://www.linkedin.com/in/jann-robert-macatangay-b5733bb3/",
    },
  },
  {
    image: member4, // DO NOT TOUCH THIS LINE
    name: "Tigra",
    role: "Chief Art Director",
  },
  {
    image: member5, // DO NOT TOUCH THIS LINE
    name: "Magic",
    role: "Marketing Manager",
  },
  {
    image: member6, // DO NOT TOUCH THIS LINE
    name: "Socio",
    role: "Social Media Manager",
  },
];

export const FAQS = [
  {
    id: 1, // DO NOT TOUCH THIS LINE
    title: "How much is a Rebel Tiger NFT?",
    content:
      "The public-sale will list a Rebel Tiger mint for 0.08ETH + Gas. The whitelisted addresses will be able to purchase a Rebel Tiger for 0.06ETH + Gas in the pre-sale.",
  },
  {
    id: 2, // DO NOT TOUCH THIS LINE
    title: "Where can I view my Rebel Tiger NFT?",
    content:
      "After a successful mint, you can view your Rebel Tiger on OpenSea by connecting your wallet.",
  },
  {
    id: 3, // DO NOT TOUCH THIS LINE
    title: "Where will I be able to mint?",
    content:
      "The minting will only take place on our official website, rebeltigerclub.com, nowhere else.",
  },
  {
    id: 4, // DO NOT TOUCH THIS LINE
    title: "Where can l mint?",
    content:
      "Pre-sale will take place a day earlier than the public-sale. The exact dates are TBD at the moment. Join our Discord to get updated first!",
  },
  {
    id: 5, // DO NOT TOUCH THIS LINE
    title: "Are there secondary market royalties?",
    content:
      "Yes.  10% of the secondary sales will be reserved for the RTC team. The team will use a portion of the royalties to finance the implementation of the development roadmap, marketing campaigns, floor sweeps and community building events.",
  },
  {
    id: 6, // DO NOT TOUCH THIS LINE
    title: "What can I do with my Rebel Tiger NFT?",
    content:
      "Owning a Rebel Tiger comes with full copyright claims. The holders have the absolute right to use their Rebel Tiger NFTs as they wish. They can use them as profile pictures, auction the NFTs out for sale, create custom merch, and stake them to earn passive $RBL income!",
  },
  {
    id: 7, // DO NOT TOUCH THIS LINE
    title: "How many addresses will be whitelisted?",
    content:
      "2000 addresses will be whitelisted and given the privelege to mint in the pre-sale.",
  },
];
